import { ItemStyleAccess } from 'containers/create-style/AddCreateStyleItem/types';
import utils from '../utils/utils';

// const protocol = process.env.REACT_APP_GRAPHQL_PROTOCOL;
// const host = process.env.REACT_APP_GRAPHQL_HOST;
// const port = process.env.REACT_APP_GRAPHQL_PORT;
// const version = process.env.REACT_APP_GRAPHQL_VERSION;
// const route = process.env.REACT_APP_GRAPHQL_ROUTE;
const API_SERVER = '';
// export const GRAPHQL_URL = `${protocol}://${host}:${port}/${version}/${route}`;
// ToDo: need to fix this. get path from .env
//const GRAPHQL_URL = `${window.location.protocol}//${window.location.hostname}:5001/taffi-stage/us-central1/graphql`;

//let hostUrl =  `${window.location.protocol}//${window.location.hostname}`;
let hostUrl = utils.getHostUrl(false);
let port = process.env.REACT_APP_USE_EMULATORS ? ':5001' : '';
const GRAPHQL_URL = process.env.REACT_APP_USE_EMULATORS
    ? `${hostUrl}${port}/taffi-stage/us-central1/graphql`
    : process.env.REACT_APP_APOLLO_HOST;
const NOTIFICATION_GRAPHQL_URL = process.env.REACT_APP_USE_EMULATORS
    ? `${hostUrl}${port}/taffi-stage/us-central1/notification_graphql`
    : process.env.REACT_APP_APOLLO_NOTIFICATION_HOST;
console.log('GRAPHQL_URL=', GRAPHQL_URL);

// ToDo: get phone # from backend
const WHATSAPP_HOST = 'https://wa.me/';
const WHATSAPP_URL = WHATSAPP_HOST + '?text=';
// ToDo: get number from backend
const TAFFI_WHATSAPP_URL = WHATSAPP_HOST + '/966507000478?text=';
const PRODUCTION_URL = 'https://www.' + process.env.REACT_APP_PRODUCTION_DOMAIN;
const TERMS_OF_SERVICE_URL = PRODUCTION_URL + '/terms-of-use';
const PRIVACY_POLICY_URL = PRODUCTION_URL + '/policy';
const ALGOLIA_HIT_PER_PAGE = 10;
const ALGOLIA_ITEM_NUMBERS = 10;
const ALGOLIA_PREFETCH_THRESHOLD = 3;
const ALGOLIA_STYLIST_PROFILE_STYLE_NUMBERS = 15;
const CALENDLY_OAUTH_LOGIN_URL = `https://calendly.com/oauth/authorize?client_id=${process.env.REACT_APP_CALENDLY_CLIENT_ID}&response_type=code&redirect_uri=${process.env.REACT_APP_CALENDLY_REDIRECT_URI}`;
const CREATE_CALENDLY_EVENT_URL = 'https://calendly.com/event_types/new/solo?return_to=%2Fevent_types%2Fuser%2Fme';
const REMOVE_CHECKOUT = true;
const config = {
    apiServer: API_SERVER,
    graphqlUrl: GRAPHQL_URL,
    notificationGraphqlUrl: NOTIFICATION_GRAPHQL_URL,
    productionUrl: PRODUCTION_URL,
    termsOfService: {
        url: TERMS_OF_SERVICE_URL,
        text: 'Terms of Service',
    },
    privacyPolicy: {
        url: PRIVACY_POLICY_URL,
        text: 'Privacy Policy',
    },
    whatsappUrl: WHATSAPP_URL,
    taffiWhatsappUrl: TAFFI_WHATSAPP_URL,
    algolia: {
        algolia_id: process.env.REACT_APP_ALGOLIA_ID,
        algolia_prefix: process.env.REACT_APP_ALGOLIA_PREFIX || '',
    },
    algoliaHitPerPage: ALGOLIA_HIT_PER_PAGE,
    algoliaHitItems: ALGOLIA_ITEM_NUMBERS,
    algoliaPrefetchThreshold: ALGOLIA_PREFETCH_THRESHOLD,
    algoliaHitStylistProfileStyles: ALGOLIA_STYLIST_PROFILE_STYLE_NUMBERS,
    whatsAppHost: WHATSAPP_HOST,
    calendlyOauthLoginUrl: CALENDLY_OAUTH_LOGIN_URL,
    createCalendlyEventUrl: CREATE_CALENDLY_EVENT_URL,
    defaultItemStyleAccessLevel: ItemStyleAccess.Private,
    removeCheckOut: REMOVE_CHECKOUT,
    widgetConstants: {
        WIDGET_INITIAL_CLOSED: 'isTaffiInitialClosed',
        TAFFI_PATH: 'taffi-path',
        TAFFI_CONTEXT: 'taffi-context',
    },
};

export default config;
